define('ShippingRestrictions.EntryPoint', [
  'ShippingRestrictions.Shipping.View',
  'ShippingRestrictions.Review.View'
], function (
  ShippingRestrictionsShippingView, // eslint-disable-line no-unused-vars
  ShippingRestrictionsReviewView // eslint-disable-line no-unused-vars
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var checkout = container.getComponent('Checkout');

      if (!checkout || typeof checkout.addModuleToStep !== 'function') {
        return;
      }

      checkout.addModuleToStep({
        step_url: 'shipping/address',
        module: {
          id: 'ShippingRestrictionsShippingView',
          index: 20,
          classname: 'ShippingRestrictions.Shipping.View'
        }
      });

      checkout.addModuleToStep({
        step_url: 'review',
        module: {
          id: 'ShippingRestrictionsReviewView',
          index: 20,
          classname: 'ShippingRestrictions.Review.View'
        }
      });
    }
  };
});
